import { Button } from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import heroImage from "~/images/property-image.jpeg";

type ExploreHeroProps = {
  signupUrl: string;
  browsePath: string;
};

export function ExploreHero({ signupUrl, browsePath }: ExploreHeroProps) {
  const { t } = useTranslation();

  return (
    <section className="explore-hero" aria-label={t("Explore_Hero_Aria")}>
      <div
        className="explore-hero-media"
        aria-hidden
        style={{
          ["--explore-hero-image" as string]: `url("${heroImage}")`,
        }}
      >
        <img src={heroImage} alt="" />
        <div className="explore-hero-overlay" />
      </div>
      <div className="explore-hero-content">
        <p className="explore-hero-brand">Bomani</p>
        <h1 className="explore-hero-headline">{t("Explore_Hero_Headline")}</h1>
        <p className="explore-hero-support">{t("Explore_Hero_Support")}</p>
        <div className="explore-hero-ctas">
          <Link to={signupUrl}>
            <Button type="primary" size="large">
              {t("Explore_Start_Free")}
            </Button>
          </Link>
          <Link to={browsePath}>
            <Button
              size="large"
              ghost
              style={{
                color: "#fff",
                borderColor: "rgba(255,255,255,0.75)",
              }}
            >
              {t("Explore_Browse_Properties")}
            </Button>
          </Link>
          <Link to={signupUrl}>
            <Button
              type="link"
              size="large"
              style={{ color: "#fff", paddingInline: 8 }}
            >
              {t("Sign_in")}
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
